/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { SchemaField, Document, DocumentSchema } from '../../../store/models/document.model';
import { DynamicField } from '../dynamic-field';
import { View, ViewComponent, WorkflowSelectionSettings } from '../../../store/models/workflow.model';
import { WorkflowStep } from 'src/app/modules/core/store/models/workflow.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { DocumentReader, DocumentWriter } from '../../../store/models';
import { TranslateService } from '@ngx-translate/core';
import { SystemNotificationsService } from '@app/core/system-notifications/system-notifications.service';

@Component({
    selector: 'app-workflow-select',
    templateUrl: './workflow-select.component.html',
    styleUrls: ['./workflow-select.component.scss'],
    standalone: false
})
export class WorkflowSelectComponent implements OnInit, OnDestroy, DynamicField, OnDestroy {
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() document: Document;
  @Input() layerUId: string;
  @Input() schema: DocumentSchema;
  @Input() viewComponent: ViewComponent;
  @Input() dataset: Dataset;
  @Input() readOnlyUser: boolean;

  workflowStepListItems: WorkflowStep[];
  selectedStepUId: string;
  selectedStatusColorCode: string;
  isActive: boolean;
  selectedStatusName: string;
  workflowTransitionView: View;
  workflowTransitionStepUId: string;
  showTransitionForm: boolean;

  value: any;
  showFieldAsEdit: boolean = false;
  private _isEdit: boolean = false;

  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = !this._isEdit && this.workflowStepListItems?.length >= 1 && !this.dataset?.isSubscribedRecord;
  }

  constructor(private notify: SystemNotificationsService, private translate: TranslateService) {}

  ngOnInit(): void {}

  tpOnContentUpdated(): void {
    const settings: WorkflowSelectionSettings = this.viewComponent.configuration?.workflowSelectionSettings;

    this.workflowStepListItems = settings.workflowStepListItems;
    this.selectedStepUId = settings.selectedStepUId;
    this.selectedStatusColorCode = settings.selectedStatusColorCode;
    this.selectedStatusName = settings.selectedStatusName;

    this.calculateShouldDisplayFieldForEdit();
  }

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  stepSelected(workflowStep: WorkflowStep): void {
    const settings: WorkflowSelectionSettings = this.viewComponent.configuration?.workflowSelectionSettings;

    const reader = new DocumentReader(this.document);

    if (!!!this.dataset) {
      return;
    }

    const currentStep = this.dataset?.workflow.workflowSteps.find(ws => ws.uId === reader.workflowStepUId);
    const currentAction = currentStep?.actions?.find(a => a.destinationStepUId === workflowStep.uId);

    var transitionView = null;
    if (currentAction?.transitionViewUId !== null) {
      transitionView = this.dataset?.workflow.views.find(v => v.uId === currentAction?.transitionViewUId);
    }

    if (!transitionView) {
      let writer = new DocumentWriter(this.document);
      writer.workflowStepUId = workflowStep.uId;
      settings.documentUpdated(writer.document);
    } else {
      this.workflowTransitionView = transitionView;
      this.workflowTransitionStepUId = workflowStep.uId;
      this.showTransitionForm = true;
    }

    settings.stepSelected(workflowStep);

    this.onValueChanged();
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }

  onCloseTransitionForm(): void {
    this.showTransitionForm = false;
  }

  onSaveTransitionForm(controls: DynamicField[] ): void {
    const writer = new DocumentWriter(this.document);

    for (const control of controls.filter(c => !!c.field)) {
      if (control?.viewComponent?.configuration?.isRequired && (!control?.value || control?.value?.length === 0)) {
        this.translate.get('MANAGEMENT.WORKFLOW.FIELD-REQUIRED').subscribe(value => {
          this.notify.error(control.field.displayName + ' ' + value);
        });

        return;
      }
      writer.setFieldValue(control.field.systemName, control.value);
    }

    writer.workflowStepUId = this.workflowTransitionStepUId;
    this.showTransitionForm = false;
    const settings: WorkflowSelectionSettings = this.viewComponent.configuration?.workflowSelectionSettings;
    settings.documentUpdated(writer.document);
  }
}
